import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import AboutUs from "./pages/aboutUs/AboutUs";
import Blog from "./pages/blogs/Blog";
import BlogContent from "./pages/blogContent/BlogContent";
import ContactUs from "./pages/contactus/contactUs";
import Privacy from "./pages/privacy/privacy";
import Condition from "./pages/conditions/condition";
import { ToastContainer } from "react-toastify";
import InspectorContact from "./pages/landingpages/inspectorContactus/InspectorContact";
import CopyRightPolicy from "./pages/copyRight/CopyRightPolicy";
import NewPrivacy from "./pages/privacy/NewPrivacy";

function App() {
  return (
    <div>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/blogs" element={<Blog />} />
        {/* <Route path="/blog-content" element={<BlogContent />} /> */}
        <Route path="/blog/:id" element={<BlogContent />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/homeowner/privacy-policy" element={<NewPrivacy />} />
        <Route path="/terms" element={<Condition />} />
        <Route path="/copyRight" element={<CopyRightPolicy />} />
        <Route path="/inspector-contact" element={<InspectorContact />} />
      </Routes>
    </div>
  );
}

export default App;
